import React from 'react';

import Tracker from '@openreplay/tracker';
import trackerAssist from '@openreplay/tracker-assist';
import trackerRedux from '@openreplay/tracker-redux';
import trackerProfiler from '@openreplay/tracker-profiler';

const tracker = new Tracker({
  projectKey: 'hhinKen4c7vz6k3O3ihy',
  ingestPoint: 'https://openreplay.timum.io/ingest',
  network: {
    capturePayload: true,
  },
  css: {
    scanInMemoryCSS: true,
  },
});
tracker.use(trackerAssist());
export const profiler = tracker.use(trackerProfiler());
export const openReplayMiddleware = tracker.use(trackerRedux());

// Module-level flag to ensure only one tracker starts per page,
// even when multiple widget instances are rendered via init()
let trackerStarted = false;

function OpenReplayHandler({
  active: activeControlled,
  api,
  delayInit, // use this to wait for requests to finish
  children,
}) {
  React.useEffect(() => {
    if (delayInit) return;

    const isActiveControlled = activeControlled !== undefined;
    let active = true;
    if (
      api === 'https://staging.timum.de' ||
      api === 'https://i4urpzk96y6mnxp72nygtivnoxczzk.local-dev.timum.io'
    ) {
      active = false;
    }

    active = isActiveControlled ? activeControlled : active;

    if (active && !trackerStarted) {
      tracker.start({
        userID: crypto.randomUUID(),
      });

      trackerStarted = true;
    }
  }, [activeControlled, api, delayInit]);

  return children;
}
export default OpenReplayHandler;
